import React from "react";
import { useTranslation} from 'react-i18next';
import CookieConsent from "react-cookie-consent";

export const Cookie = () => {
  const { t } = useTranslation(); 

  return (
      <CookieConsent
        debug={false}
        location="bottom"
        buttonText={t("Cookie.accept")}
        declineButtonText={t("Cookie.decline")}
        cookieName="cookies"
        enableDeclineButton
        onDecline={() => {
          localStorage.setItem("cookies", "no");
        }}  
        onAccept={(acceptedByScrolling) => {
          if (acceptedByScrolling) {
            localStorage.setItem("cookies", "yes");
          } else {
            localStorage.setItem("cookies", "yes");
          }
        }} 
        containerClasses="cookie-container"             
        buttonStyle={{ background: "green", color: "white", fontSize: "13px", height: "35px", borderRadius: "5px" }}
        declineButtonStyle={{background: "red", color: "white", fontSize: "13px", height: "35px", borderRadius: "5px"}}
        expires={150}
      >
        {t("Cookie.text")}{" "}
      </CookieConsent>       
  );
};
